import vCheckbox from "./v-checkbox.vue";
import vCheckboxGroup from "./extensions/v-checkbox-group/v-checkbox-group.vue";
import vCheckboxChannels from "./extensions/v-checkbox-channels/v-checkbox-channels.vue";

export default Vue => {
  Vue.component("v-checkbox", vCheckbox);
  Vue.component("v-checkbox-group", vCheckboxGroup);
  Vue.component("v-checkbox-channels", vCheckboxChannels);
};
